import { useState } from 'react';
import type { FormEvent } from 'react';

interface TextCommandInputProps {
  onSubmit: (command: string) => void | Promise<void>;
  disabled?: boolean;
}

function TextCommandInput({ onSubmit, disabled = false }: TextCommandInputProps) {
  const [command, setCommand] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmedCommand = command.trim();
    if (!trimmedCommand || disabled) {
      return;
    }
    void onSubmit(trimmedCommand);
    setCommand('');
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '0.75rem' }}>
      <label htmlFor="fill-blank-command">Command</label>
      <input
        id="fill-blank-command"
        type="text"
        value={command}
        onChange={(event) => setCommand(event.target.value)}
        disabled={disabled}
      />
      <button type="submit" disabled={disabled || !command.trim()}>
        Submit
      </button>
    </form>
  );
}

export default TextCommandInput;
